let fontPlus = document.getElementById('font-plus');

let fontMinus = document.getElementById('font-minus');

fontPlus.addEventListener("click", function(e) {
    let root = document.documentElement;
    let ajust = getComputedStyle(root)
        .getPropertyValue('--ajust-font-size');
    ajust = (parseInt(ajust) + 1) + 'px';
    root.style.setProperty('--ajust-font-size', ajust);
});
fontMinus.addEventListener("click", function(e) {
    let root = document.documentElement;
    let ajust = getComputedStyle(root)
        .getPropertyValue('--ajust-font-size');
    ajust = (parseInt(ajust) - 1) + 'px';
    root.style.setProperty('--ajust-font-size', ajust);
});

//Calculer la position des sous sous menu en fonction de la width du parent (le plus haut sinon width pas calculé)
var submenu = document.getElementsByClassName("subsubmenu");
for (let elt of submenu) {
    let parent = elt.closest('.first');
    if (parent != null) {
        let width = parent.clientWidth;
        elt.style.left = width + 'px';
    }
}

console.log(submenu);


// WEBPACK FOOTER //
// ./src/js/app/global.js